window.PXUTheme = window.PXUTheme || {};

window.PXUTheme.jsSmartGallery = {
  async init() {
    // Selectors
    this.imageParent = document.querySelector(".smart-gallery");
    this.inactiveGallery = document.querySelector(".smart-gallery-inactive");
    this.flickityInstance = null;

    if (!this.imageParent || !this.inactiveGallery) {
      console.error("Smart Gallery containers not found.");
      return;
    }

    if (document.querySelector(".smart-gallery__limiter")) {
      this.watchLimiters();
    }

    this.selectedVariant = this.imageParent.dataset.selectedVariant || "";
    this.watchSwappers(); // Watch for changes in variant
    this.updateActiveImages();
    this.watchGallerySwatches();
    this.lockGalleryHeight(); // Lock the height of the gallery
    window.addEventListener("resize", this.lockGalleryHeightBound = this.lockGalleryHeight.bind(this));
  },

  lockGalleryHeight() {
    if (!this.imageParent) return;
    const height = this.imageParent.offsetHeight;
    this.imageParent.style.minHeight = `${height}px`;
  },

  watchLimiters() {
    const limiters = document.querySelectorAll(".smart-gallery__limiter");
    for (const limiter of limiters) {
      limiter.addEventListener("click", (event) => {
        limiter.parentNode.querySelector(".smart-gallery").classList.add("unlimited");
        event.target.classList.add("hidden");
      });
    }
  },

  watchGallerySwatches() {
    const swatches = document.querySelectorAll(".gallery-swatches .gallery-swatch");
    for (const swatch of swatches) {
      swatch.addEventListener("click", (event) => {
        if (document.querySelector(".gallery-swatches .gallery-swatch.active")) {
          document.querySelector(".gallery-swatches .gallery-swatch.active").classList.remove("active");
        }
        swatch.classList.add("active");

        // event.preventDefault();

        // Manually select the corresponding input
        const input = document.getElementById(`input-swatch--${swatch.dataset.swapper}`);
        if (input) {
          input.checked = true;
          input.closest("fieldset").dataset.stickySelection = "selected";
          window.PXUTheme.jsGlobalProduct.updateFloatingATC();
        }

        if (document.querySelector(".swatch__options-selection")) {
          document.querySelector(".swatch__options-selection").textContent = swatch.dataset.colour;
        }
      });
    }
  },

  // Initialize Flickity if screen width is below 768px
  initializeFlickityIfNeeded() {
    // if (window.innerWidth < 768) {
    if (window.innerWidth < 768 || this.imageParent.classList.contains("carousel")) {
      // Ensure imageParent exists
      if (!this.imageParent) {
        console.error("Cannot initialize Flickity: imageParent is not defined.");
        return;
      }

      let showDots = false;
      if (this.imageParent.classList.contains("dots")) {
        showDots = true;
      }

      // Initialize Flickity
      this.flickityInstance = new Flickity(this.imageParent, {
        cellAlign: "left",
        contain: true,
        pageDots: showDots,
        prevNextButtons: true,
        wrapAround: true,
        imagesLoaded: true,
      });
    } else {
      if (this.flickityInstance) {
        this.flickityInstance.destroy();
      }
    }
  },

  // Update the active images based on the selected variant
  updateActiveImages(newVariant = this.selectedVariant) {
    // If Flickity is initialized, destroy it to reset the gallery
    if (this.flickityInstance) {
      this.flickityInstance.destroy();
      this.flickityInstance = null;
    }

    // Remove all child elements efficiently
    while (this.imageParent.firstChild) {
      this.imageParent.removeChild(this.imageParent.firstChild);
    }

    const matchingCells = [];
    const inactiveCells = this.inactiveGallery.querySelectorAll("div.gallery-cell");

    inactiveCells.forEach((cell) => {
      const anchor = cell.querySelector("a");
      const smartImg = anchor?.querySelector("smartimg");

      if (smartImg && (newVariant === "false" || smartImg.getAttribute("alt") === `xs:${newVariant}`)) {
        const clonedCell = cell.cloneNode(true);
        const clonedAnchor = clonedCell.querySelector("a");
        const clonedSmartImg = clonedAnchor?.querySelector("smartimg");

        if (clonedSmartImg) {
          const video = clonedSmartImg.querySelector("video");

          if (video) {
            // Handle video: extract video and icons from <smartimg>
            const pauseIcon = clonedSmartImg.querySelector(".gicon--pause");

            // Create a container for the video and icons
            const videoContainer = document.createElement("div");
            videoContainer.classList.add("video-wrapper");
            videoContainer.appendChild(video);
            if (pauseIcon) videoContainer.appendChild(pauseIcon.cloneNode(true));

            clonedSmartImg.replaceWith(videoContainer);
          } else {
            // Handle image: create an <img> element and map attributes
            const img = document.createElement("img");
            this.copyAttributes(clonedSmartImg, img); // Copy src, srcset, alt, etc.
            clonedSmartImg.replaceWith(img);
          }
        }

        clonedAnchor.classList.remove("hidden");
        matchingCells.push(clonedCell);
      }
    });

    // Use DocumentFragment to minimize reflows
    const fragment = document.createDocumentFragment();
    matchingCells.forEach((cell) => fragment.appendChild(cell));
    this.imageParent.appendChild(fragment);

    // Reinitialize Flickity if needed
    this.initializeFlickityIfNeeded();
    this.watchVideoActions();
  },

  watchVideoActions() {
    document.querySelectorAll(".gallery-cell video").forEach((video) => {
      const parent = video.closest(".gallery-cell");
      const icon = parent.querySelector(".gicon");

      icon.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (video.paused) {
          video.play();
          icon.classList.add("gicon--pause");
          icon.classList.remove("gicon--play");
        } else {
          video.pause();
          icon.classList.remove("gicon--pause");
          icon.classList.add("gicon--play");
        }
      });
    });
  },

  // Function to copy all attributes and dataset from one element to another
  copyAttributes(fromElement, toElement) {
    Array.from(fromElement.attributes).forEach((attr) => {
      toElement.setAttribute(attr.name, attr.value);
    });

    Array.from(fromElement.dataset).forEach((value, key) => {
      toElement.dataset[key] = value;
    });
  },

  // Function to toggle the visibility of the anchor based on its contents
  toggleAnchorVisibility(anchor, newVariant) {
    const img = anchor.querySelector("img");
    const smartImg = anchor.querySelector("smartimg");

    if (img && img.getAttribute("alt") === `xs:${newVariant}`) {
      anchor.classList.remove("hidden");
    } else if (smartImg && smartImg.getAttribute("alt") === `xs:${newVariant}`) {
      anchor.classList.add("hidden");
    }
  },

  // Watch for changes in variant selection and update gallery
  watchSwappers() {
    const variantSelectors = document.querySelectorAll("[data-swapper]");

    if (variantSelectors.length === 0) {
      console.warn("No variant swappers found.");
      return;
    }

    variantSelectors.forEach((swapper) => {
      swapper.addEventListener("change", (event) => {
        const newVariant = event.target.dataset.swapper;
        if (swapper.closest(".product-bundle__option")) {
          const titleEl = swapper.closest(".product-bundle__option").querySelector("[data-selected-colour]");
          titleEl.textContent = event.target.dataset.title;
        }

        if(document.querySelector('[data-select-colour] b')) {
          const title = document.querySelector('[data-select-colour] b');
          title.textContent = event.target.dataset.colour;
        }

        // Update dataset for smart-gallery and reinitialize
        this.imageParent.dataset.selectedVariant = newVariant;
        this.selectedVariant = newVariant;
        this.updateActiveImages(newVariant);
      });

      swapper.addEventListener('click', (event) => {
        // event.preventDefault();
        const newVariant = event.target.dataset.swapper;

        if (swapper.closest(".product-bundle__option")) {
          const titleEl = swapper.closest(".product-bundle__option").querySelector("[data-selected-colour]");
          titleEl.textContent = event.target.dataset.title;
        }

        if(document.querySelector('[data-select-colour] b')) {
          const title = document.querySelector('[data-select-colour] b');
          title.textContent = event.target.dataset.colour;
        }

        // Update dataset for smart-gallery and reinitialize
        this.imageParent.dataset.selectedVariant = newVariant;
        this.selectedVariant = newVariant;
        this.updateActiveImages(newVariant);
      });
    });
  },
};

// Initialize Smart Gallery
document.addEventListener("DOMContentLoaded", () => {
  window.PXUTheme.jsSmartGallery.init();
});

// Listen for window resize events to reinitialize Flickity when the screen resizes
window.addEventListener("resize", () => {
  window.PXUTheme.jsSmartGallery.initializeFlickityIfNeeded();
});
